/* config.js — datos de contacto reales de Peicar (decisión: usar los del sitio actual,
 * NO los del handoff de diseño; ver plan-landing-rediseno.md).
 * Única fuente de verdad para la Landing2: si cambia el número/email, se cambia aquí. */

export const WA_PHONE = '8148947395';
export const waLink = (message) =>
  `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(message)}`;

/* Sin texto prellenado: se usa DESPUÉS de que el backend ya le mandó la
 * plantilla, cuando la conversación ya existe y solo hay que abrirla. */
export const waChatLink = () => `https://wa.me/${WA_PHONE}`;

/* Los 10 dígitos de un celular mexicano, o null si no son 10.
 * Tolera "+52", "+521", espacios, guiones y paréntesis. Vive aquí porque lo usan
 * el LeadModal (captura) y el ContinueModal (reintento con otro número), y tener
 * dos copias de esta regla es pedir que se separen. */
export const telA10Digitos = (valor) => {
  const d = String(valor ?? '').replace(/\D/g, '');
  if (d.length === 10) return d;
  if (d.length === 12 && d.startsWith('52')) return d.slice(2);
  if (d.length === 13 && d.startsWith('521')) return d.slice(3);
  return null;
};

export const EMAIL = 'contacto@peicar.com.mx';
export const PHONE_DISPLAY = 'T. 8148947395';

export const ADDRESS_LINES = [
  'Tintoreto 92 Int. 402, Ciudad de los Deportes',
  'Benito Juárez, Ciudad de México 03710',
];

export const CITIES = 'CDMX · Edo. Méx. · Guadalajara';

export const INSTAGRAM_URL = 'https://instagram.com/peicar';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/peicar';

export const DEFAULT_WA_MESSAGE =
  'Hola, me gustaría saber más sobre el servicio de Peicar';
